import React from 'react';

interface FavoriteButtonProps {
    isFavorite: boolean;
    onToggle: () => void;
    className?: string;
}

const FavoriteButton = ({ isFavorite, onToggle, className = '' }: FavoriteButtonProps) => {
    return (
        <button 
            className={`icon-button font-24 ${className}`}
            onClick={onToggle}
            title={isFavorite ? "Remove from favorites" : "Add to favorites"}
        >
            <i className={`mdi ${isFavorite ? 'mdi-star text-pliable' : 'mdi-star-outline'}`}></i>
        </button>
    );
};

export default FavoriteButton;